import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert, Button } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { message } from "antd";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { DownloadTableExcel } from "react-export-table-to-excel";
import usePagination from "../../../../components/usePagination/usePagination";
import Pagination from "@material-ui/lab/Pagination";
import Select from "react-select";
function ManagePhoneBook() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [schoolObject, setSchoolObject] = useState({
    label: "Select Previous School",
    value: "",
  });

  const [previousSchoolData, setPreviousSchoolData] = useState([]);
  const [previousSchoolList, setPreviousSchoolList] = useState([]);
  const [phoneBookData, setPhoneBookData] = useState([]);
  const [schoolId, setSchoolId] = useState("");
  const [schoolName, setSchoolName] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [yearId, setYearId] = useState("");
  const [yearName, setYearName] = useState([]);
  const [phoneBookLoading, setAddPhoneBookLoading] = useState(false);

  const [addPhoneBookModal, setAddPhoneBookModal] = useState(false);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [phone, setPhone] = useState("");
  const [remarks, setRemarks] = useState("");

  const [editPhoneBookModal, setEditPhoneBookModal] = useState(false);
  const [editName, setEditName] = useState("");
  const [editAddress, setEditAddress] = useState("");
  const [editMobileNo, setEditMobileNo] = useState("");
  const [editPhone, setEditPhone] = useState("");
  const [editRemarks, setEditRemarks] = useState("");
  const [editPhoneBookId, setEditPhoneBookId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deletePhoneBookId, setDeletePhoneBookId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [selectedBookIds, setSelectedBookIds] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);

  const [open, setOpen] = useState(false);
  const [messagedata, setMessageData] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [buttonDisabled, setbuttonDisabled] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const key = "updatable";

  const [studentMessage, setStudentMessage] = useState("");
  const [characterCount, setCharacterCount] = useState(0);
  const [messageCount, setMessageCount] = useState(1);
  const [assignMessage, setAssignMessage] = useState(0);
  const [remainingMessage, setRemainingMessage] = useState(0);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const inputRef = useRef(null);
  const pageStyle = `
  @page {
    size: a4 !important;
  }
  `;
  const onBeforeGetContentResolve = React.useRef(null);
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const tableRef = useRef(null);

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(phoneBookData.length / PER_PAGE);
  const _DATA = usePagination(phoneBookData, PER_PAGE);

  useEffect(() => {
    getSettingData();
    sessions();
    getPreviousSchool();
    getUnitMessages();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPreviousSchool = async () => {
    await fetch(`${baseUrl}/previous-school`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setPreviousSchoolData(data.payload);
          let arr = [];
          data.payload.forEach((element) => {
            arr.push({
              label: element.name,
              value: element.id,
            });
          });
          setPreviousSchoolList(arr);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getManagePhoneBook = async () => {
    if (yearId == "") {
      return alert.error("Session Is Required");
    }
    let yearName = sessionData.find((item) => item.id == yearId);
    setYearName(yearName);

    let schoolName = previousSchoolData.find((item) =>
      item.id == schoolObject?.value ? schoolObject.value : "",
    );
    setSchoolName(schoolName);

    const data = {
      year_id: yearId,
      previous_school_id: schoolObject?.value ? schoolObject.value : "",
    };
    setloading(true);

    await fetch(`${baseUrl}/get-phone-book`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            let res = data.payload;
            let temparr = res;
            res.map((item, index) => {
              item["SrNo"] = index + 1;
              temparr[index] = item;
            });
            setPhoneBookData(temparr);
          } else if (data.payload.length > 0 || !data.metadata.success) {
            alert.error("No Record Found!!");
          } else {
            alert.error("No Record Found!!");
          }
          setloading(false);
        }),
      )
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addPhoneBookHandler = async () => {
    if (yearId == "" || schoolId == "" || name == "" || mobileNo == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      year_id: yearId,
      previous_school_id: schoolId,
      name: name,
      address: address,
      mobile_no: mobileNo,
      phone: phone,
      remarks: remarks,
    };
    setAddPhoneBookLoading(true);

    await fetch(`${baseUrl}/manage-phone-book`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Student Added To Phone Book Successfully!!");
            // setAddPhoneBookModal(false);
            setAddPhoneBookLoading(false);
            getManagePhoneBook();
            setName("");
            setAddress("");
            setMobileNo("");
            setPhone("");
            setRemarks("");
            if (inputRef.current) {
              inputRef.current.focus();
            }
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddPhoneBookModal(false);
            setAddPhoneBookLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddPhoneBookModal(false);
            setAddPhoneBookLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddPhoneBookLoading(false);
        setAddPhoneBookModal(false);
        console.log(err);
      });
  };

  const getEditPhoneBook = async (id) => {
    await fetch(`${baseUrl}/manage-phone-book/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setYearId(data.payload?.year_setting_id);
          setSchoolId(data.payload?.previous_school_id);
          setEditName(data.payload?.name);
          setEditAddress(data.payload?.address);
          setEditMobileNo(data.payload?.mobile_no);
          setEditPhone(data.payload?.phone);
          setEditRemarks(data.payload?.remarks);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updatePhoneBookHandler = async () => {
    if (yearId == "") {
      return alert.error("Session Is Required");
    }
    if (schoolId == "") {
      return alert.error("School Id Is Required");
    }
    if (editName == "" || editMobileNo == "") {
      return alert.error("Name Or Mobile Number Is Required");
    }

    setSubmitLoading(true);
    const data = {
      year_id: yearId,
      previous_school_id: schoolId,
      name: editName,
      address: editAddress,
      mobile_no: editMobileNo,
      phone: editPhone,
      remarks: editRemarks,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/manage-phone-book/${editPhoneBookId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Student Updated To Phone Book Successfully!!");
            getManagePhoneBook();
            setEditPhoneBookModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditPhoneBookModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditPhoneBookModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deletePhoneBookHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/manage-phone-book/${deletePhoneBookId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getManagePhoneBook();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  // Handle Checkboxes
  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedBookIds([]);
    }

    phoneBookData.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedIds(item);
      } else {
        AddSelectedIds(item);
      }
    });
  };

  // const checkAllCheckBoxes = () => {
  //   if (studentchallans.length == selectedChallans.length) {
  //     setmaincheckboxChecked(true);
  //   } else if (mainCheckBoxChecked) {
  //     setmaincheckboxChecked(false);
  //   }
  // };

  const handleStdIdsCheckBoxClick = (e, index) => {
    phoneBookData.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedIds(item);
        } else {
          RemoveSelectedIds(item);
        }
      }
    });
  };

  const AddSelectedIds = (item) => {
    setSelectedBookIds((prevSelectedBookIds) => [
      ...prevSelectedBookIds,
      item.id,
    ]);
  };

  const RemoveSelectedIds = (item) => {
    setSelectedBookIds((prevSelectedBookIds) =>
      prevSelectedBookIds.filter((id) => id !== item.id),
    );
  };

  const handleChangeBook = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  // Message Mechanism
  const getUnitMessages = async () => {
    await fetch(`${baseUrl}/get-unit-messages`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAssignMessage(data?.payload?.assign_sms);
        setRemainingMessage(data?.payload?.remaining_sms);
      })
      .catch((err) => {
        console.log("error: ", err);
      });
  };

  const handleChange = (event) => {
    const inputMessage = event.target.value;
    const currentCharacterCount = inputMessage.length;
    const currentMessageCount = Math.ceil(currentCharacterCount / 160);

    setStudentMessage(inputMessage);
    setCharacterCount(currentCharacterCount);
    setMessageCount(currentMessageCount);
  };

  const handleModelOpen = () => {
    if (selectedBookIds.length > 0) {
      setOpen(true);
    } else {
      alert.error("Please Select The At least 1 student");
    }
  };

  const sendMessage = () => {
    setConfirmModal(false);
    setOpen(false);
    setbuttonDisabled(false);
    setMessageData("");
    setbuttonDisabled(true);

    let data = {
      message: studentMessage,
      phone_book_ids: selectedBookIds,
    };

    fetch(`${baseUrl}/phone-book-custom-sms`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata) {
            if (data.metadata.success) {
              setOpen(false);
              setMessageData("");
              messageApi.open({
                key,
                type: "success",
                content: "Successfully Send",
                duration: 1,
              });
              setbuttonDisabled(false);
              setConfirmModal(false);
            } else {
              messageApi.open({
                key,
                type: "error",
                content: "Something went wrong",
                duration: 4,
              });
              setbuttonDisabled(false);
              setConfirmModal(false);
            }
          }
          console.log(data);
        }),
      )

      .catch((err) => {
        console.log(err);
      });
  };

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  return (
    <div>
      {contextHolder}
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddPhoneBookModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Phone Book
          </button>

          <button onClick={handleModelOpen} className="btn btn-primary">
            Send Message
          </button>
        </div>

        <div className="row mt-9">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => setYearId(e.target.value)}
              >
                <option value=""> Select Session</option>
                {sessionData &&
                  sessionData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-5">
            <label>
              <b>Select Previous School </b>{" "}
              <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              value={schoolObject}
              onChange={(e) => setSchoolObject(e)}
              className="disselect"
              placeholder="Select Previous School"
              options={previousSchoolList}
              isClearable
            />
          </div>

          <div className="col-md-4 mt-9">
            <button className="btn btn-primary" onClick={getManagePhoneBook}>
              Show Phone Book
            </button>

            {phoneBookData.length > 0 && (
              <>
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle={`Mange Phone Book`}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-100px mx-2"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <DownloadTableExcel
                  filename="Mange Phone Book"
                  sheet="Mange Phone Book"
                  currentTableRef={tableRef.current}
                >
                  {phoneBookData.length > 0 && (
                    <button className="btn btn-primary mx-2">Export</button>
                  )}
                </DownloadTableExcel>
              </>
            )}
          </div>
        </div>

        <Table className="mt-5">
          <thead>
            <tr className="text-center">
              <th style={{ width: "5px" }}>
                <input type="checkbox" style={{ display: "none" }} />
                <label className="checkbox checkbox-single">
                  <input
                    onClick={(e) => {
                      handleMainCheckboxClick();
                    }}
                    checked={mainCheckBoxChecked}
                    style={{}}
                    placeholder="Checkbox"
                    type="checkbox"
                    readOnly
                  />
                  <span />
                </label>
              </th>
              <th>ID</th>
              <th>Previous School Name</th>
              <th>Name</th>
              <th>Address</th>
              <th>Mobile No</th>
              <th>Phone</th>
              <th>Remarks</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {_DATA.currentData()?.map((data, index) => (
              <tr className="text-center" key={index}>
                <td style={{ width: "5px" }}>
                  <input type="checkbox" style={{ display: "none" }} />
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      value={data.id}
                      key={data.id}
                      onClick={(e) => {
                        handleStdIdsCheckBoxClick(e, data.id);
                      }}
                      checked={data.checked ?? false}
                      style={{ border: "10px" }}
                      readOnly
                    ></input>
                    <span />
                  </label>
                </td>
                <td>{data?.SrNo}</td>
                <td>{data?.previous_school?.name}</td>
                <td>{data?.name}</td>
                <td>{data?.address ? data?.address : "--"}</td>
                <td>{data?.mobile_no}</td>
                <td>{data?.phone ? data?.phone : "--"}</td>
                <td>{data?.remarks ? data?.remarks : "--"}</td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {
                      getEditPhoneBook(data?.id);
                      setEditPhoneBookId(data?.id);
                      setEditPhoneBookModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {
                      setDeletePhoneBookId(data?.id);
                      setdeleteModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Delete-user.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        <Pagination
          color="primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChangeBook}
        />

        <div>
          <div
            ref={componentRef}
            id="printSection"
            className="customTablePrint"
          >
            <div className="p-3" style={{ display: "flex" }}>
              <img style={{ height: 100, width: 110 }} src={icon} alt="logo" />

              <div className="col-md-8" style={{ paddingTop: "25px" }}>
                <h1>{unitName}</h1>
                <div className="d-flex justify-content-between">
                  <h3>
                    Manage Phone Book of {schoolName?.name} for Session{" "}
                    {yearName?.year}{" "}
                  </h3>
                </div>
              </div>
            </div>

            <Table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Sr.No</b>
                  </th>
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    <b>Student Name</b>
                  </th>
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    {" "}
                    Address
                  </th>

                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    Mobile No
                  </th>

                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    Phone No
                  </th>
                  <th
                    style={{ fontSize: "16px", border: "1px solid black" }}
                    className="text-center"
                  >
                    Remarks
                  </th>
                </tr>
              </thead>
              <tbody>
                {phoneBookData.map((item, index) => (
                  <tr key={index}>
                    <td
                      className="text-center"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      className="text-start"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                        paddingLeft: "10px",
                      }}
                    >
                      {item?.name}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {item?.address ? item?.address : "--"}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {item?.mobile_no}
                    </td>

                    <td
                      className="text-center"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {item?.phone ? item?.phone : "--"}
                    </td>

                    <td
                      className="text-center"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        border: "1px solid black",
                        padding: "1px",
                      }}
                    >
                      {item?.remarks ? item?.remarks : "--"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        <div>
          <div ref={tableRef} id="printSection" className="customTablePrint">
            <div className="p-3" style={{ display: "flex" }}>
              <div className="col-md-8" style={{ paddingTop: "25px" }}>
                <h1>{unitName}</h1>
                <div className="d-flex justify-content-between">
                  <h3>
                    Manage Phone Book of {schoolName?.name} for Session{" "}
                    {yearName?.year}{" "}
                  </h3>
                </div>
              </div>
            </div>

            <Table className="mt-5">
              <thead>
                <tr className="text-center">
                  <th>ID</th>
                  <th>Previous School Name</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Mobile No</th>
                  <th>Phone</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {phoneBookData?.map((data, index) => (
                  <tr className="text-center" key={index}>
                    <td>{index + 1}</td>
                    <td>{data?.previous_school?.name}</td>
                    <td>{data?.name}</td>
                    <td>{data?.address ? data?.address : "--"}</td>
                    <td>{data?.mobile_no}</td>
                    <td>{data?.phone ? data?.phone : "--"}</td>
                    <td>{data?.remarks ? data?.remarks : "--"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Add Previous SchoolModal */}
        <Modal show={addPhoneBookModal} size="lg">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              addPhoneBookHandler();
            }}
          >
            <Modal.Header className="modal_header_style" closeButton>
              <Modal.Title
                className="Modal_Heading_font"
                id="contained-modal-title-vcenter"
              >
                Add Phone Book
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="row mb-4">
                <div className="col-md-6">
                  <label>
                    <b>Select Session </b>{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-select form-control"
                    name="session_id"
                    value={yearId}
                    onChange={(e) => setYearId(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Session</option>
                    {sessionData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.year}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label>
                    <b>Select Previous School </b>{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={
                      previousSchoolList.find(
                        (item) => item.value == schoolId,
                      ) || null
                    }
                    onChange={(e) => {
                      setSchoolId(e ? e.value : "");
                    }}
                    className="disselect"
                    placeholder="Select Previous School"
                    options={previousSchoolList}
                    isClearable
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Student Nmae <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    ref={inputRef}
                    className="form-control"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Student Name"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Mobile No. <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="mobile_no"
                    value={mobileNo}
                    type="tel"
                    onChange={(e) => {
                      if (e.target.value.length <= 11) {
                        setMobileNo(e.target.value);
                      }
                    }}
                    placeholder="Enter Mobile No."
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Address <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Enter Address"
                    disabled={
                      !PremissionChecker(
                        user,
                        "student.can_add_address_phone_remarks",
                      )
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Phone <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Enter Phone"
                    disabled={
                      !PremissionChecker(
                        user,
                        "student.can_add_address_phone_remarks",
                      )
                    }
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Remarks <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="remarks"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter Remarks"
                    disabled={
                      !PremissionChecker(
                        user,
                        "student.can_add_address_phone_remarks",
                      )
                    }
                  />
                </div>
              </div>

              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>

            <Modal.Footer>
              {phoneBookLoading ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                <button className="btn btn-success button_blue" type="submit">
                  Add
                </button>
              )}
              <button
                type="button"
                className="btn btn-danger btn_width"
                onClick={() => {
                  setAddPhoneBookModal(false);
                  setisallfields(false);
                  setName("");
                }}
              >
                Cancel
              </button>
            </Modal.Footer>
          </form>
        </Modal>

        {/* Update Previous SchoolModal */}
        <Modal show={editPhoneBookModal} size="lg">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updatePhoneBookHandler();
            }}
          >
            <Modal.Header className="modal_header_style" closeButton>
              <Modal.Title
                className="Modal_Heading_font"
                id="contained-modal-title-vcenter"
              >
                Update Phone Book
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row mb-4">
                <div className="col-md-6">
                  <label>
                    <b>Select Session </b>{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-select form-control"
                    name="session_id"
                    value={yearId}
                    onChange={(e) => setYearId(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Session</option>
                    {sessionData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.year}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label>
                    <b>Select Previous School </b>{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={
                      previousSchoolList.find(
                        (item) => item.value == schoolId,
                      ) || null
                    }
                    onChange={(e) => {
                      setSchoolId(e ? e.value : "");
                    }}
                    className="disselect"
                    placeholder="Select Previous School"
                    options={previousSchoolList}
                    isClearable
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Student Nmae <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="edit_name"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    placeholder="Enter Student Name"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Address <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="edit_address"
                    value={editAddress}
                    onChange={(e) => setEditAddress(e.target.value)}
                    placeholder="Enter Address"
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Mobile No. <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="edit_mobile_no"
                    value={editMobileNo}
                    type="number"
                    onChange={(e) => {
                      if (e.target.value.length <= 11) {
                        setEditMobileNo(e.target.value);
                      }
                    }}
                    placeholder="Enter Mobile No."
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Phone <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="edit_phone"
                    value={editPhone}
                    onChange={(e) => setEditPhone(e.target.value)}
                    placeholder="Enter Phone"
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Enter Remarks <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <input
                    className="form-control"
                    name="edit_remarks"
                    value={editRemarks}
                    onChange={(e) => setEditRemarks(e.target.value)}
                    placeholder="Enter Remarks"
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              {submitLoading ? (
                <div
                  style={{
                    width: "80px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Spinner
                    className="text-center"
                    variant="info"
                    animation="border"
                  />
                </div>
              ) : (
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              )}

              <button
                type="button"
                onClick={() => setEditPhoneBookModal(false)}
                className="btn btn-danger"
              >
                Close
              </button>
            </Modal.Footer>
          </form>
        </Modal>

        {/* Delete  Previous School Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this phone book?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deletePhoneBookHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>

        {/* Message Sending Modals */}
        <Modal show={open} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Message Editor
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <textarea
                  rows="4"
                  cols="50"
                  placeholder="Write the Message..."
                  value={studentMessage}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "5px" }}
                ></textarea>
                <div
                  className="d-flex justify-content-between"
                  style={{ fontSize: "14px" }}
                >
                  <h6>Character Count: {characterCount}</h6>
                  <h6>Message Count: {messageCount}</h6>
                </div>
                <div
                  className="d-flex justify-content-between"
                  style={{ fontSize: "14px" }}
                >
                  <h6 className="blue_color">
                    Remaining Messages: {remainingMessage}
                  </h6>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => setConfirmModal(true)}
              className="btn btn-primary mx-2"
            >
              Send Message
            </button>

            <button onClick={() => setOpen(false)} className="btn btn-danger">
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={confirmModal} onHide={() => setConfirmModal(false)}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Send Message
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>Are You Sure You Want To Send Message</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setConfirmModal(false)}>
              Close
            </Button>
            <Button
              disabled={buttonDisabled}
              variant="primary"
              onClick={sendMessage}
            >
              Send
            </Button>
          </Modal.Footer>
        </Modal>
      </Paper>
    </div>
  );
}

export default ManagePhoneBook;
